import { render, staticRenderFns } from "./ProposalSettings.vue?vue&type=template&id=e81be71a&"
import script from "./ProposalSettings.vue?vue&type=script&lang=js&"
export * from "./ProposalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports